import 'jquery-zoom';

class Zoom {

  constructor(elem) {
    this.zoom = elem;
	}

  initialize() {
    let el = this.zoom;
    let img = el.attr('data-zoom');

    this.zoom.zoom({
      url: img,
      on: 'grab',
    });
	}
}

export {Zoom};

$(window).on('load', () => {

});
